// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountCapabilitiesArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {
  Exact,
  OpenapiAccountCapabilitiesCardPaymentsEnum,
  OpenapiAccountCapabilitiesFpxPaymentsEnum,
  OpenapiAccountCapabilitiesIndiaInternationalPaymentsEnum,
  OpenapiAccountCapabilitiesJcbPaymentsEnum,
  OpenapiAccountCapabilitiesTransfersEnum,
  OpenapiAccountCapabilitiesTreasuryEnum,
  OpenapiAccountCapabilitiesAchDebitPaymentsEnum,
  OpenapiAccountCapabilitiesAcssDebitPaymentsEnum,
  OpenapiAccountCapabilitiesAffirmPaymentsEnum,
  OpenapiAccountCapabilitiesAfterpayClearpayPaymentsEnum,
  OpenapiAccountCapabilitiesAlipayPaymentsEnum,
  OpenapiAccountCapabilitiesApplePayLaterPaymentsEnum,
  OpenapiAccountCapabilitiesAuBecsDebitPaymentsEnum,
  OpenapiAccountCapabilitiesBacsDebitPaymentsEnum,
  OpenapiAccountCapabilitiesBacsDebitStripeSunPaymentsEnum,
  OpenapiAccountCapabilitiesBancontactPaymentsEnum,
  OpenapiAccountCapabilitiesBankTransferPaymentsEnum,
  OpenapiAccountCapabilitiesBeneficiaryTransfersEnum,
  OpenapiAccountCapabilitiesBlikPaymentsEnum,
  OpenapiAccountCapabilitiesBoletoPaymentsEnum,
  OpenapiAccountCapabilitiesCardIssuingEnum,
  OpenapiAccountCapabilitiesCartesBancairesPaymentsEnum,
  OpenapiAccountCapabilitiesCashAdvancesEnum,
  OpenapiAccountCapabilitiesCashappPaymentsEnum,
  OpenapiAccountCapabilitiesCompanyFormationEnum,
  OpenapiAccountCapabilitiesCorporateCardsBalanceCardEnum,
  OpenapiAccountCapabilitiesCorporateCardsChargeCardEnum,
  OpenapiAccountCapabilitiesCryptoTransfersEnum,
  OpenapiAccountCapabilitiesEpsPaymentsEnum,
  OpenapiAccountCapabilitiesFundingCreditEnum,
  OpenapiAccountCapabilitiesGiropayPaymentsEnum,
  OpenapiAccountCapabilitiesGrabpayPaymentsEnum,
  OpenapiAccountCapabilitiesIdBankTransferPaymentsEnum,
  OpenapiAccountCapabilitiesIdBankTransferPaymentsBcaEnum,
  OpenapiAccountCapabilitiesIdCreditTransferPaymentsEnum,
  OpenapiAccountCapabilitiesIdealPaymentsEnum,
  OpenapiAccountCapabilitiesKlarnaPaymentsEnum,
  OpenapiAccountCapabilitiesKonbiniPaymentsEnum,
  OpenapiAccountCapabilitiesLegacyPaymentsEnum,
  OpenapiAccountCapabilitiesLinkPaymentsEnum,
  OpenapiAccountCapabilitiesLoansEnum,
  OpenapiAccountCapabilitiesMetaPayPaymentsEnum,
  OpenapiAccountCapabilitiesMobilepayPaymentsEnum,
  OpenapiAccountCapabilitiesMultibancoPaymentsEnum,
  OpenapiAccountCapabilitiesNetbankingPaymentsEnum,
  OpenapiAccountCapabilitiesNzBankAccountBecsDebitPaymentsEnum,
  OpenapiAccountCapabilitiesOxxoPaymentsEnum,
  OpenapiAccountCapabilitiesP24PaymentsEnum,
  OpenapiAccountCapabilitiesPayByBankPaymentsEnum,
  OpenapiAccountCapabilitiesPaymentsEnum,
  OpenapiAccountCapabilitiesPaynowPaymentsEnum,
  OpenapiAccountCapabilitiesPaypalPaymentsEnum,
  OpenapiAccountCapabilitiesPixPaymentsEnum,
  OpenapiAccountCapabilitiesPromptpayPaymentsEnum,
  OpenapiAccountCapabilitiesRechnungPaymentsEnum,
  OpenapiAccountCapabilitiesRevolutPayPaymentsEnum,
  OpenapiAccountCapabilitiesSepaDebitPaymentsEnum,
  OpenapiAccountCapabilitiesSofortPaymentsEnum,
  OpenapiAccountCapabilitiesStripeCardEnum,
  OpenapiAccountCapabilitiesSubmerchantPaymentsEnum,
  OpenapiAccountCapabilitiesTaxReportingUs1099KEnum,
  OpenapiAccountCapabilitiesTaxReportingUs1099MiscEnum,
  OpenapiAccountCapabilitiesUpiPaymentsEnum,
  OpenapiAccountCapabilitiesUsBankAccountAchPaymentsEnum,
  OpenapiAccountCapabilitiesWechatPayPaymentsEnum,
  OpenapiAccountCapabilitiesZipPaymentsEnum,
  OpenapiAccountCapabilitiesAmazonPayPaymentsEnum,
  OpenapiAccountCapabilitiesCardIssuingChargeCardEnum,
  OpenapiAccountCapabilitiesDemoPayPaymentsEnum,
  OpenapiAccountCapabilitiesDuitnowPaymentsEnum,
  OpenapiAccountCapabilitiesSouthKoreaMarketPaymentsEnum,
  OpenapiAccountCapabilitiesSwishPaymentsEnum,
  OpenapiAccountCapabilitiesTreasuryGoldmanSachsEnum,
  OpenapiAccountCapabilitiesAlmaPaymentsEnum,
  OpenapiAccountCapabilitiesTreasuryFifthThirdEnum,
  OpenapiAccountCapabilitiesTreasuryEvolveEnum,
  OpenapiAccountCapabilitiesCardIssuingSpendCardCrossRiverEnum,
  OpenapiAccountCapabilitiesAutomaticIndirectTaxEnum,
  OpenapiAccountCapabilitiesFundAndSendEnum,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAccountCapabilitiesArkFragment on OpenapiAccountCapabilities {
    ach_debit_payments
    acss_debit_payments
    affirm_payments
    afterpay_clearpay_payments
    alipay_payments
    alma_payments
    apple_pay_later_payments
    amazon_pay_payments
    au_becs_debit_payments
    automatic_indirect_tax
    bacs_debit_payments
    bacs_debit_stripe_sun_payments
    bancontact_payments
    bank_transfer_payments
    beneficiary_transfers
    blik_payments
    boleto_payments
    card_issuing
    card_issuing_charge_card
    card_issuing_spend_card_cross_river
    card_payments
    cartes_bancaires_payments
    cash_advances
    cashapp_payments
    company_formation
    corporate_cards_balance_card
    corporate_cards_charge_card
    crypto_transfers
    demo_pay_payments
    duitnow_payments
    eps_payments
    fpx_payments
    fund_and_send
    funding_credit
    giropay_payments
    grabpay_payments
    id_bank_transfer_payments
    id_bank_transfer_payments_bca
    id_credit_transfer_payments
    ideal_payments
    india_international_payments
    jcb_payments
    klarna_payments
    konbini_payments
    legacy_payments
    link_payments
    loans
    meta_pay_payments
    mobilepay_payments
    multibanco_payments
    netbanking_payments
    nz_bank_account_becs_debit_payments
    oxxo_payments
    p24_payments
    pay_by_bank_payments
    payments
    paynow_payments
    paypal_payments
    pix_payments
    promptpay_payments
    rechnung_payments
    revolut_pay_payments
    sepa_debit_payments
    sofort_payments
    south_korea_market_payments
    stripe_card
    submerchant_payments
    swish_payments
    tax_reporting_us_1099_k
    tax_reporting_us_1099_misc
    transfers
    treasury
    treasury_evolve
    treasury_fifth_third
    treasury_goldman_sachs
    upi_payments
    us_bank_account_ach_payments
    wechat_pay_payments
    zip_payments
  }
`;

export const stripeAccountCapabilitiesArkFragment: StripeAccountCapabilitiesArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountCapabilitiesArkFragmentData = {
  readonly __typename: 'OpenapiAccountCapabilities';
  readonly ach_debit_payments: OpenapiAccountCapabilitiesAchDebitPaymentsEnum | null;
  readonly acss_debit_payments: OpenapiAccountCapabilitiesAcssDebitPaymentsEnum | null;
  readonly affirm_payments: OpenapiAccountCapabilitiesAffirmPaymentsEnum | null;
  readonly afterpay_clearpay_payments: OpenapiAccountCapabilitiesAfterpayClearpayPaymentsEnum | null;
  readonly alipay_payments: OpenapiAccountCapabilitiesAlipayPaymentsEnum | null;
  readonly alma_payments: OpenapiAccountCapabilitiesAlmaPaymentsEnum | null;
  readonly apple_pay_later_payments: OpenapiAccountCapabilitiesApplePayLaterPaymentsEnum | null;
  readonly amazon_pay_payments: OpenapiAccountCapabilitiesAmazonPayPaymentsEnum | null;
  readonly au_becs_debit_payments: OpenapiAccountCapabilitiesAuBecsDebitPaymentsEnum | null;
  readonly automatic_indirect_tax: OpenapiAccountCapabilitiesAutomaticIndirectTaxEnum | null;
  readonly bacs_debit_payments: OpenapiAccountCapabilitiesBacsDebitPaymentsEnum | null;
  readonly bacs_debit_stripe_sun_payments: OpenapiAccountCapabilitiesBacsDebitStripeSunPaymentsEnum | null;
  readonly bancontact_payments: OpenapiAccountCapabilitiesBancontactPaymentsEnum | null;
  readonly bank_transfer_payments: OpenapiAccountCapabilitiesBankTransferPaymentsEnum | null;
  readonly beneficiary_transfers: OpenapiAccountCapabilitiesBeneficiaryTransfersEnum | null;
  readonly blik_payments: OpenapiAccountCapabilitiesBlikPaymentsEnum | null;
  readonly boleto_payments: OpenapiAccountCapabilitiesBoletoPaymentsEnum | null;
  readonly card_issuing: OpenapiAccountCapabilitiesCardIssuingEnum | null;
  readonly card_issuing_charge_card: OpenapiAccountCapabilitiesCardIssuingChargeCardEnum | null;
  readonly card_issuing_spend_card_cross_river: OpenapiAccountCapabilitiesCardIssuingSpendCardCrossRiverEnum | null;
  readonly card_payments: OpenapiAccountCapabilitiesCardPaymentsEnum | null;
  readonly cartes_bancaires_payments: OpenapiAccountCapabilitiesCartesBancairesPaymentsEnum | null;
  readonly cash_advances: OpenapiAccountCapabilitiesCashAdvancesEnum | null;
  readonly cashapp_payments: OpenapiAccountCapabilitiesCashappPaymentsEnum | null;
  readonly company_formation: OpenapiAccountCapabilitiesCompanyFormationEnum | null;
  readonly corporate_cards_balance_card: OpenapiAccountCapabilitiesCorporateCardsBalanceCardEnum | null;
  readonly corporate_cards_charge_card: OpenapiAccountCapabilitiesCorporateCardsChargeCardEnum | null;
  readonly crypto_transfers: OpenapiAccountCapabilitiesCryptoTransfersEnum | null;
  readonly demo_pay_payments: OpenapiAccountCapabilitiesDemoPayPaymentsEnum | null;
  readonly duitnow_payments: OpenapiAccountCapabilitiesDuitnowPaymentsEnum | null;
  readonly eps_payments: OpenapiAccountCapabilitiesEpsPaymentsEnum | null;
  readonly fpx_payments: OpenapiAccountCapabilitiesFpxPaymentsEnum | null;
  readonly fund_and_send: OpenapiAccountCapabilitiesFundAndSendEnum | null;
  readonly funding_credit: OpenapiAccountCapabilitiesFundingCreditEnum | null;
  readonly giropay_payments: OpenapiAccountCapabilitiesGiropayPaymentsEnum | null;
  readonly grabpay_payments: OpenapiAccountCapabilitiesGrabpayPaymentsEnum | null;
  readonly id_bank_transfer_payments: OpenapiAccountCapabilitiesIdBankTransferPaymentsEnum | null;
  readonly id_bank_transfer_payments_bca: OpenapiAccountCapabilitiesIdBankTransferPaymentsBcaEnum | null;
  readonly id_credit_transfer_payments: OpenapiAccountCapabilitiesIdCreditTransferPaymentsEnum | null;
  readonly ideal_payments: OpenapiAccountCapabilitiesIdealPaymentsEnum | null;
  readonly india_international_payments: OpenapiAccountCapabilitiesIndiaInternationalPaymentsEnum | null;
  readonly jcb_payments: OpenapiAccountCapabilitiesJcbPaymentsEnum | null;
  readonly klarna_payments: OpenapiAccountCapabilitiesKlarnaPaymentsEnum | null;
  readonly konbini_payments: OpenapiAccountCapabilitiesKonbiniPaymentsEnum | null;
  readonly legacy_payments: OpenapiAccountCapabilitiesLegacyPaymentsEnum | null;
  readonly link_payments: OpenapiAccountCapabilitiesLinkPaymentsEnum | null;
  readonly loans: OpenapiAccountCapabilitiesLoansEnum | null;
  readonly meta_pay_payments: OpenapiAccountCapabilitiesMetaPayPaymentsEnum | null;
  readonly mobilepay_payments: OpenapiAccountCapabilitiesMobilepayPaymentsEnum | null;
  readonly multibanco_payments: OpenapiAccountCapabilitiesMultibancoPaymentsEnum | null;
  readonly netbanking_payments: OpenapiAccountCapabilitiesNetbankingPaymentsEnum | null;
  readonly nz_bank_account_becs_debit_payments: OpenapiAccountCapabilitiesNzBankAccountBecsDebitPaymentsEnum | null;
  readonly oxxo_payments: OpenapiAccountCapabilitiesOxxoPaymentsEnum | null;
  readonly p24_payments: OpenapiAccountCapabilitiesP24PaymentsEnum | null;
  readonly pay_by_bank_payments: OpenapiAccountCapabilitiesPayByBankPaymentsEnum | null;
  readonly payments: OpenapiAccountCapabilitiesPaymentsEnum | null;
  readonly paynow_payments: OpenapiAccountCapabilitiesPaynowPaymentsEnum | null;
  readonly paypal_payments: OpenapiAccountCapabilitiesPaypalPaymentsEnum | null;
  readonly pix_payments: OpenapiAccountCapabilitiesPixPaymentsEnum | null;
  readonly promptpay_payments: OpenapiAccountCapabilitiesPromptpayPaymentsEnum | null;
  readonly rechnung_payments: OpenapiAccountCapabilitiesRechnungPaymentsEnum | null;
  readonly revolut_pay_payments: OpenapiAccountCapabilitiesRevolutPayPaymentsEnum | null;
  readonly sepa_debit_payments: OpenapiAccountCapabilitiesSepaDebitPaymentsEnum | null;
  readonly sofort_payments: OpenapiAccountCapabilitiesSofortPaymentsEnum | null;
  readonly south_korea_market_payments: OpenapiAccountCapabilitiesSouthKoreaMarketPaymentsEnum | null;
  readonly stripe_card: OpenapiAccountCapabilitiesStripeCardEnum | null;
  readonly submerchant_payments: OpenapiAccountCapabilitiesSubmerchantPaymentsEnum | null;
  readonly swish_payments: OpenapiAccountCapabilitiesSwishPaymentsEnum | null;
  readonly tax_reporting_us_1099_k: OpenapiAccountCapabilitiesTaxReportingUs1099KEnum | null;
  readonly tax_reporting_us_1099_misc: OpenapiAccountCapabilitiesTaxReportingUs1099MiscEnum | null;
  readonly transfers: OpenapiAccountCapabilitiesTransfersEnum | null;
  readonly treasury: OpenapiAccountCapabilitiesTreasuryEnum | null;
  readonly treasury_evolve: OpenapiAccountCapabilitiesTreasuryEvolveEnum | null;
  readonly treasury_fifth_third: OpenapiAccountCapabilitiesTreasuryFifthThirdEnum | null;
  readonly treasury_goldman_sachs: OpenapiAccountCapabilitiesTreasuryGoldmanSachsEnum | null;
  readonly upi_payments: OpenapiAccountCapabilitiesUpiPaymentsEnum | null;
  readonly us_bank_account_ach_payments: OpenapiAccountCapabilitiesUsBankAccountAchPaymentsEnum | null;
  readonly wechat_pay_payments: OpenapiAccountCapabilitiesWechatPayPaymentsEnum | null;
  readonly zip_payments: OpenapiAccountCapabilitiesZipPaymentsEnum | null;
};

export type StripeAccountCapabilitiesArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountCapabilitiesArkFragmentPermissions = {} as const;

doc.permissions = stripeAccountCapabilitiesArkFragmentPermissions;

export type StripeAccountCapabilitiesArkFragmentPermissions = V1PermissionToken<
  typeof stripeAccountCapabilitiesArkFragmentPermissions
>;

export type StripeAccountCapabilitiesArkFragmentDocument = GraphQlDocument<
  StripeAccountCapabilitiesArkFragmentData,
  StripeAccountCapabilitiesArkFragmentVariables,
  StripeAccountCapabilitiesArkFragmentPermissions
>;
